import { YEAR_MS } from '@dr.pogodin/js-utils';
import type { UseAsyncDataResT } from '@dr.pogodin/react-global-state';

import { deleteAsset, listAssets } from 'services/assets';
import { type AssetT, useAsyncCollection } from 'utils';

export type UseUserAssetsResT = UseAsyncDataResT<AssetT[]> & {
  deleteAsset(id: string): Promise<void>;
};

export function useUserAssets(userId: string): UseUserAssetsResT {
  const result = useAsyncCollection(
    userId,
    'assets.byUser',
    async (id) => {
      if (!id) return [];
      const res = await listAssets({ userId: id });
      return res.assets;
    },
    { maxage: YEAR_MS },
  );

  return {
    ...result,

    // TODO: This, sure can be optimized, to not reload everything,
    // and to not wait, but this simple variant will do for now.
    async deleteAsset(id): Promise<void> {
      await deleteAsset(id);
      await result.reload();
    },
  };
}
